import React from 'react';
import { Tag, Tooltip } from 'antd';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
  MinusCircleOutlined,
  HourglassOutlined,
  RightOutlined
} from '@ant-design/icons';
import { ApprovalFlowStep, ApprovalFlowStepStatus } from '../../../types/approval.types';

const STATUS_CONFIG: Record<ApprovalFlowStepStatus, { color: string; label: string; icon: React.ReactNode }> = {
  approved: { color: 'green', label: 'Onayladı', icon: <CheckCircleOutlined /> },
  rejected: { color: 'red', label: 'Reddetti', icon: <CloseCircleOutlined /> },
  skipped: { color: 'default', label: 'Atlandı', icon: <MinusCircleOutlined /> },
  current: { color: 'gold', label: 'Sırada (karar bekleniyor)', icon: <ClockCircleOutlined /> },
  waiting: { color: 'default', label: 'Bekliyor', icon: <HourglassOutlined /> },
};

interface ApprovalFlowTagsProps {
  steps?: ApprovalFlowStep[] | null;
}

/** Onay akışı adımlarını kompakt etiketler halinde gösterir */
const ApprovalFlowTags: React.FC<ApprovalFlowTagsProps> = ({ steps }) => {
  if (!steps || steps.length === 0) return null;

  const sorted = [...steps].sort((a, b) => a.step - b.step);

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', rowGap: 6 }}>
      {sorted.map((step, index) => {
        const config = STATUS_CONFIG[step.status] || STATUS_CONFIG.waiting;
        return (
          <React.Fragment key={`${step.step}-${step.approverId}`}>
            <Tooltip title={`${step.step}. adım - ${config.label}`}>
              <Tag
                color={config.color}
                icon={config.icon}
                style={{ marginInlineEnd: 0, textDecoration: step.status === 'skipped' ? 'line-through' : undefined }}
              >
                {step.step}. {step.approverName}
              </Tag>
            </Tooltip>
            {index < sorted.length - 1 && (
              <RightOutlined style={{ fontSize: 10, color: '#bfbfbf', margin: '0 4px' }} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ApprovalFlowTags;
